<template>
    <div class="controlItemWrapper" :class="control.className" :data-control-name="control.name">
        <div class="controlItem row" :id="control.name" v-if="labelPosition === 'left'">
            <div class="col-md-4">
                <label :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}">
                    {{control.label}}
                </label>
            </div>
            <div class="col-md-8 input-group">
              <WorkflowButtons   
                :data='rowData' 
                :firstStep='firstStep'
                :workflow='workflow'
                :gridId="gridId"
              />
            </div>
        </div>
        <div class="controlItem row" :id="control.name" v-else>
            <div class="form-group col-md-12">
                <label :class="{'bold': control.labelBold, 'italic': control.labelItalic, 'underline': control.labelUnderline}">
                    {{control.label}}
                </label>
                <div class="input-group">
                    <WorkflowButtons   
                      :data='rowData' 
                      :firstStep='firstStep'
                      :workflow='workflow'
                      :gridId="gridId"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import WorkflowButtons from '@/components/WorkflowButtons'
  import { mapState } from "vuex";

  export default {
    name: "WorkflowControl",
    props: ['control', 'labelPosition', 'gridId', 'rowData'],
    components: {
      WorkflowButtons
    },
    computed: {
      ...mapState(['dataGrid_options']),
      firstStep(){
        if(this.gridId){
          return this.dataGrid_options[this.gridId].meta[this.control.propName].startTitle
        }
      },
      workflow(){
        if(this.gridId){
          return this.dataGrid_options[this.gridId].meta[this.control.propName].workflow
        }
      }
    }
  }
</script>

<style scoped>

</style>
